import { type ModalProps, Modal } from "./Modal";
import clsx from 'clsx';
import s from './TabbedModal.module.scss';

export function TabbedModal(props: ModalProps) {
  return <Modal {...props} contentClassName={clsx(props.contentClassName, s['content'])} modalClassName={clsx(props.modalClassName, s['modal-body'])} />;
}
